import { MenuChildItemInterface } from 'utils/types/oraclePayment/MenuItem';
import { Collapse, Detail, CondimentWrapper } from './index.view';
import { currencyFormat } from 'utils/number';
import { useTranslation } from 'react-i18next';

interface CondimentsProps {
  subMenus: MenuChildItemInterface[];
  isShow: boolean;
}

const SubMenu = ({ subMenus, isShow }: CondimentsProps) => {
  const { t } = useTranslation();

  return (
    <Collapse in={isShow}>
      {subMenus.map((item, index) => (
        <CondimentWrapper key={index}>
          <Detail>{`${item.quantity}x ${item.titleOriginal} , ${item.nameOriginal}`}</Detail>
          <Detail>{item.total ? `${currencyFormat(item.total)}` : t('billExtraPriceFree')}</Detail>
        </CondimentWrapper>
      ))}
    </Collapse>
  );
};

export default SubMenu;
